import { DefaultStageMapping, DefaultStageMappingType } from '../../../api/integrations';
import { DropResult } from 'react-beautiful-dnd';

// Define the hidden stage type constant
export const HIDDEN_STAGE_TYPE = 'HIDDEN' as const;

// Define the stage types
export const STAGE_TYPES = [
    { value: 'INTRODUCED', label: 'Introduced' },
    { value: 'INTERVIEW', label: 'Interview' },
    { value: 'OFFERED', label: 'Offered' },
    { value: 'HIRED', label: 'Hired' },
    { value: 'REJECTED', label: 'Rejected' },
    { value: 'ON_HOLD', label: 'On Hold' },
] as const;

// Core stage information
export interface StageInfo {
    id: string;
    name: string;
    mapping: DefaultStageMapping;
    isNew?: boolean;
    isChanged?: boolean;
}

// Grouped stage with additional properties
export interface GroupedStage {
    id: string;
    name: string;
    originalId: string;
    mapping: Partial<DefaultStageMapping> & {
        stage_type?: DefaultStageMappingType | null;
        order?: number | null;
        is_unmapped?: boolean;
    };
    isNew?: boolean;
    isChanged?: boolean;
}

// Stage group type definition
export interface StageGroup {
    stageType: DefaultStageMappingType | 'UNMAPPED' | typeof HIDDEN_STAGE_TYPE;
    label: string;
    stages: GroupedStage[];
    isExpanded: boolean;
}

// Using DropResult directly instead of extending it to avoid type conflicts
export type StageDragResult = DropResult;

// Counts for tracking changes
export interface ChangeCount {
    addedCount: number;
    updatedCount: number;
    unmappedCount: number;
}

// The main hook's return type
export interface StageMappingHookResult {
    loading: boolean;
    saving: boolean;
    atsConnected: boolean;
    noJobsConnected: boolean;
    originalStages: StageInfo[];
    stageGroups: StageGroup[];
    filteredGroups: StageGroup[];
    searchQuery: string;
    selectedStages: Set<string>;
    selectedCount: number;
    addedCount: number;
    updatedCount: number;
    unmappedCount: number;
    setSearchQuery: (query: string) => void;
    toggleGroupExpansion: (groupIndex: number) => void;
    toggleStageSelection: (stageId: string) => void;
    handleDragEnd: (result: StageDragResult) => void;
    applyStageTypeToSelected: (stageType: DefaultStageMappingType | null, isUnmapped?: boolean) => void;
    handleSaveConfirm: () => Promise<void>;
    handleResetChanges: () => void;
    clearSelection: () => void;
    toggleAlwaysUnmap: (stageId: string, unmapped: boolean) => void;
} 